module.exports = __webpack_public_path__ + "images/decorator-6de08a.svg";